import React, { useEffect, useState } from 'react'
import history from "../../route/history";
import { connect } from 'react-redux'
import { memberAppActions } from '../../store/actions/main/memberApp.actions';

import { uriConstants } from '../../store/constants';
import axios from 'axios'

const Setting = (props) => {
	const [appAtmcLgnYn, setAppAtmcLgnYn] = useState("")
  	const [state, setState] = useState({})
  	const [user, setUser] = useState({})

	const prePage = (e) => {
		e.preventDefault();
		window.history.back()
	  }

	  // 자동 로그인 여부 초기화
	  useEffect(() => {
		setUser(props.auth?.user?.payload)
		try { 
		    const checkObj = {
		      deviceId: window.M.info.device('uuid'),
			  modMemberId : 'testestest!!!'
		    }
            props.get(checkObj)   
        } catch(e) {
            if(e.name === 'RangeError'){

    		}else{
              throw(e)
            }
		}
	  }, [])

	  useEffect(() => {
		setAppAtmcLgnYn(props?.data?.appAtmcLgnYn)
		if(props?.data?.appAtmcLgnYn !== undefined){
			//window.M.data.storage(props?.data?.setting?.appAtmcLgnYn, props?.data?.setting?.appAtmcLgnYn)
			window.M.data.storage('appAtmcLgnYn', props?.data?.appAtmcLgnYn)
		}
	  }, [props?.data?.appAtmcLgnYn])

	  const checkHandler = (e) => {
	    const { id, checked } = e.target
		console.log(id,checked)
		let logTest ={}
	    if(id === 'appAtmcLgnYn' && checked === true){
			window.M.data.removeStorage("memberId")
			window.M.data.removeStorage("N")
			window.M.data.storage('appAtmcLgnYn', 'Y')
		    const checkObj = {
		      deviceId: window.M.info.device("uuid"),
		      memberId: props?.data?.memberId,
		      appAtmcLgnYn: "Y"
		    }
			props.updateAutoLoginYn(checkObj)
		}else if(id === 'appAtmcLgnYn' && checked !== true){
			window.M.data.storage('memberId', props?.data?.memberId)
			window.M.data.removeStorage("Y")
			window.M.data.storage('appAtmcLgnYn', 'N')
		    const checkObj = {
		      deviceId: window.M.info.device("uuid"),
		      memberId: props?.data?.memberId,
		      appAtmcLgnYn: "N"
		    }
			props.updateAutoLoginYn(checkObj)
		}else if(id === 'almPushYn' && checked === true){
			console.log(user.memberId)
			console.log(user.memberName)
			logTest.url = 'setting.jsx 68'
			logTest.user = props?.data
			axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',logTest,{headers:{},})
			window.M.plugin('push').remote.registerServiceAndUser({
				// cuid: props?.data?.memberId,
				// name: props?.data?.memberName,
				cuid: user.memberId,
				name: user.memberName,
				callback: function( status ) {
					console.log('status : ' + JSON.stringify(status));
					var info = window.M.plugin('push').info();
					
					if (status.status == 'SUCCESS') {
						console.log('[' + info.CLIENT_UID + '/' + info.CLIENT_NAME + ']의 서비스/유저 등록을 성공 하였습니다.');
					} else {
						console.log('[' + info.CLIENT_UID + '/' + info.CLIENT_NAME + ']의 서비스/유저 등록을 실패 하였습니다.');
					}
					logTest = {}
					logTest.url = 'setting.jsx 83'
					logTest.status = status
					logTest.pushInfo = info
					axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',logTest,{headers:{},})
				}
			});
		    const checkObj = {
		      memberId: props?.data?.memberId,
		      almPushYn: "Y"
		    }
			props.updateAlmPushYn(checkObj)
		}else if(id === 'almPushYn' && checked !== true){
			window.M.plugin('push').remote.unregisterService({
			        callback: function( status, setting ) {
			        var info = window.M.plugin('push').info();
			
			        if(status == 'SUCCESS') {
			            console.log('[' + info.CLIENT_UID + '/' + info.CLIENT_NAME + ']의 서비스 해제가 성공 하였습니다.');
			        }
			        else {
			            console.log('[' + info.CLIENT_UID + '/' + info.CLIENT_NAME + ']의 서비스 해제가 실패 하였습니다.');
			        }
			    }
			});
		    const checkObj = {
		      memberId: props?.data?.memberId,
		      almPushYn: "N",
			  deviceId : window.M.info.device('uuid')
		    }
			props.updateAlmPushYn(checkObj)
		}
	    
	    
	  }
	  
	return(
		<React.Fragment>
			<div id="contents">	
				<div className="content-header type2">
					<a href="#" className="page-prev" onClick={prePage}>뒤로이동</a>
					<h2>환경설정</h2>
					<div className="breadcrumb">
						<span>Home</span><em>환경설정</em>
					</div>
				</div>
				<ul className="setup-list">
					<li>
						<p className="tit">이용정보 알림</p>
						<p className="txt">전자문서지갑 서비스 이용 내역을 수신받을 수 있습니다.</p>
          				<span className="chk"><input type="checkbox" id='almPushYn' className="toggle" checked={props?.data?.almPushYn === 'Y'} onChange={checkHandler} /><em></em></span>
					</li>
					{/*
					<li>
						<p className="tit">자동 로그인</p>
          				<span className="chk"><input type="checkbox" id='appAtmcLgnYn' className="toggle" checked={props?.data?.appAtmcLgnYn === 'Y'} onChange={checkHandler} /><em></em></span>
					</li>
					 */}
				</ul>
			</div>
		</React.Fragment>
	)
}

const mapStateToProps = (state) => {
	return {
		data : state.setting?.settingInfo,
		auth: state.auth,
	}
  }

const actionCreators = {
	updateAlmPushYn: memberAppActions.updateAlmPushYn,
	updateAutoLoginYn: memberAppActions.updateAutoLoginYn,
	get: memberAppActions.get,
  }

export default connect(mapStateToProps, actionCreators)(Setting)